export default __webpack_public_path__ + "static/0144-0aadebf53a18899c61c8cc5c2bbc13a2.png";